import axios from "axios";
import { baseURL } from "../core";

// Read the token fresh on each call — the agent may have logged in after this
// module was first imported, so a module-level snapshot would be stale.
const authHeaders = () => ({
  authorization: `Bearer ${localStorage.getItem("jToken")}`,
});

// Persist the wizard step as the agent advances so a refresh / device switch
// resumes mid-flow. Best-effort: failures are swallowed by callers.
const updateOnboardingStep = async (step) => {
  const res = await axios.post(
    `${baseURL}/agent/update-onboarding-step`,
    { step },
    { headers: authHeaders() }
  );
  return res.data?.agent;
};

// Mark onboarding finished. Mirrors the updated agent into localStorage so the
// login gate sees onboarding.completedAt immediately without a refetch.
const completeOnboarding = async ({ skippedWalkthrough = false } = {}) => {
  const res = await axios.post(
    `${baseURL}/agent/complete-onboarding`,
    { skippedWalkthrough },
    { headers: authHeaders() }
  );
  const agent = res.data?.agent;
  if (agent) {
    localStorage.setItem("agent", JSON.stringify(agent));
  }
  return agent;
};

// Mark the in-app spotlight walkthrough as seen. Independent from
// completeOnboarding so existing agents who never went through the chromeless
// flow still get the one-time tour the first time we ship it.
const completeWalkthrough = async ({ skipped = false } = {}) => {
  const res = await axios.post(
    `${baseURL}/agent/complete-walkthrough`,
    { skipped },
    { headers: authHeaders() }
  );
  const agent = res.data?.agent;
  if (agent) {
    localStorage.setItem("agent", JSON.stringify(agent));
  }
  return agent;
};

const OnboardingService = {
  updateOnboardingStep,
  completeOnboarding,
  completeWalkthrough,
};

export default OnboardingService;
